import { render, staticRenderFns } from "./c_member_benefits.vue?vue&type=template&id=4134c51f&scoped=true"
import script from "./c_member_benefits.vue?vue&type=script&lang=js"
export * from "./c_member_benefits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4134c51f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4134c51f')) {
      api.createRecord('4134c51f', component.options)
    } else {
      api.reload('4134c51f', component.options)
    }
    module.hot.accept("./c_member_benefits.vue?vue&type=template&id=4134c51f&scoped=true", function () {
      api.rerender('4134c51f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfig/c_member_benefits.vue"
export default component.exports